module.exports = __webpack_public_path__ + "static/media/W75F3005-WEB5.6ee34219.svg";